export default __webpack_public_path__ + "i18n/ro.9d5b8686a6eeb4eb977d85e3898bda04.json";